import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { AuthLoginRequestBody, AuthLoginResponse } from "../../core/api/requests/auth/login/types";
import { AuthForgotPasswordRequestBody } from "../../core/api/requests/auth/forgot-password/types";
import { AuthResetPasswordRequestBody } from "../../core/api/requests/auth/reset-password/types";
import { User } from "./types";
import { LogoutRequestBody, LogoutResponse } from "../../core/api/requests/auth/logout/types";

const actionCreator = actionCreatorFactory("@@Auth");

export const authActions = {
    setIsLoggedIn: actionCreator<boolean>("SET_IS_LOGGED_IN"),
    setIsInitialized: actionCreator<boolean>("SET_IS_INITIALIZED"),
    getUser: actionCreator.async<CommonAsyncType, User>("GET_USER"),
    login: actionCreator.async<CommonAsyncType<AuthLoginResponse> & AuthLoginRequestBody, {}>("LOGIN"),
    forgotPassword: actionCreator.async<CommonAsyncType & AuthForgotPasswordRequestBody, {}>("FORGOT_PASSWORD"),
    resetPassword: actionCreator.async<CommonAsyncType & AuthResetPasswordRequestBody, {}>("RESET_PASSWORD"),
    logout: actionCreator.async<CommonAsyncType & LogoutRequestBody, LogoutResponse>("LOGOUT"),
    resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
}